import React from "react";
import { X } from "lucide-react";
import { Button } from "../../../design-system/components/primitives/Button/Button";
import { Body, Description, Footer, Header, HeaderText, Kicker, Shell, Status, StatusError, Title } from "./TaskDialog.styles";
import type { TaskDialogProps } from "./TaskDialog.types";

/** A large task dialog with a status line and one main action in its footer. */
export const TaskDialog: React.FC<TaskDialogProps> = ({
  open,
  onClose,
  id,
  kicker,
  title,
  description,
  closeLabel,
  children,
  status,
  statusError,
  cancelLabel,
  primary,
  primaryVariant = "primary",
  width,
}) => (
  <Shell width={width} open={open} onClose={onClose} size="workspace" ariaLabelledBy={`${id}-title`}>
    <Header>
      <HeaderText>
        {kicker ? <Kicker>{kicker}</Kicker> : null}
        <Title id={`${id}-title`} tabIndex={-1}>
          {title}
        </Title>
        {description ? <Description id={`${id}-description`}>{description}</Description> : null}
      </HeaderText>
      <Button variant="ghost" size="sm" iconOnly aria-label={closeLabel} onClick={onClose}>
        <X aria-hidden="true" />
      </Button>
    </Header>
    <Body>{children}</Body>
    <Footer>
      <Status role="status">
        {status}
        {statusError ? <StatusError>{statusError}</StatusError> : null}
      </Status>
      <Button variant="secondary-outline" size="md" onClick={onClose}>
        {cancelLabel}
      </Button>
      <Button
        variant={primaryVariant}
        size="md"
        disabled={primary.disabled || primary.loading}
        loading={primary.loading}
        iconBefore={primary.icon}
        onClick={primary.onClick}
      >
        {primary.label}
      </Button>
    </Footer>
  </Shell>
);

export default TaskDialog;
